// extracted by mini-css-extract-plugin
module.exports = {"message-box":"_3G6awp","message-box--positive":"u05wbu","message-box--negative":"_192laR"};